import { SplitContentHtmlConfig } from "../splitContentTypes";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { HtmlEditor } from "./html/HtmlEditor";
// import { SplitContentAttachHtmlExamples } from "./SplitContentAttachHtmlExamples";

interface Props {
  onClose: () => void;
  onAttached: (config: SplitContentHtmlConfig) => void;
  currentConfig?: SplitContentHtmlConfig;
}

const formSchema = z.object({
  html: z.string().min(1),
});

type FormSchemaType = z.infer<typeof formSchema>;

export const SplitContentAttachHtmlDialog: React.FC<Props> = ({ onClose, onAttached, currentConfig }) => {
  const { t } = useTranslation();

  const form = useForm<FormSchemaType>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      html: currentConfig?.html || "",
    },
  });

  const onSubmit = (values: FormSchemaType) => {
    const conf: SplitContentHtmlConfig = {
      type: "html",
      html: values.html,
    };
    onAttached(conf);
    onClose();
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="overflow-y-auto max-w-[90vw] h-[90vh]">
        <DialogHeader>
          <DialogTitle>{t("splitContent.attachHtml")}</DialogTitle>
          <DialogDescription className="flex flex-row gap-4">
            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8 flex-1 flex-shrink-0">
                <FormField
                  control={form.control}
                  name="html"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>HTML</FormLabel>
                      <FormControl>
                        <HtmlEditor value={field.value} onChange={field.onChange} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <Button type="submit">{t("common.add")}</Button>
              </form>
            </Form>
            {/* <SplitContentAttachHtmlExamples /> */}
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
